export const SPRITE_SIZE = 40;
export const MAP_HEIGHT = SPRITE_SIZE * 10;
export const MAP_WIDTH = SPRITE_SIZE * 20;
